import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '@app/core/services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const authServiceOfUser = this.authenticationService.currentTenant;
    if (authServiceOfUser && authServiceOfUser.configuration && authServiceOfUser.configuration.auth) {
    // if (currentTenants) {
      // logged in so return true
      return true;
    }
    this.router.navigate(['/auth/login']);

    return false;
  }
}
